import type { MonthRevenue } from 'src/secret-menu/billing/hooks/useRevenue';
import { monthKeyOfDate } from '../overview/usageModel';

type Comparison = {
  current: number;
  /** Null when no snapshot was taken last month, so there is nothing to compare with. */
  previous: number | null;
  change: number | null;
};

export function compare(current: number, previous: number | null): Comparison {
  if (previous === null) return { current, previous, change: null };
  return {
    current,
    previous,
    change: current - previous,
  };
}

/** Last month's closing totals, if a snapshot was taken in it. */
export function lastMonthOf(history: readonly MonthRevenue[], today: Date): MonthRevenue | null {
  const lastMonth = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1));
  const key = monthKeyOfDate(lastMonth);
  return history.find(entry => entry.month.startsWith(key)) ?? null;
}
